import React from 'react';
import Investors from 'templates/investors';

const InvestorsPage = () => (
  <Investors />
);

export default InvestorsPage;
